import { render, staticRenderFns } from "./ContactEmailsModal.vue?vue&type=template&id=80e4c3c6&"
import script from "./ContactEmailsModal.vue?vue&type=script&lang=ts&"
export * from "./ContactEmailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80e4c3c6')) {
      api.createRecord('80e4c3c6', component.options)
    } else {
      api.reload('80e4c3c6', component.options)
    }
    module.hot.accept("./ContactEmailsModal.vue?vue&type=template&id=80e4c3c6&", function () {
      api.rerender('80e4c3c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/ContactEmailsModal.vue"
export default component.exports